import type { HelpFile } from '../../types/help'
import { PeerRecommendationListTestIds } from '../../../testids/PeerRecommendationListTestIds'

export const peerRecommendationListHelp: HelpFile = {
  docPage: '/docs/access/peer-recommendations',
  texts: {
    [PeerRecommendationListTestIds.peerRecommendationList]:
      'Zugriffsprofile, die Peers in derselben Rolle oder Organisation bereits besitzen — hilfreich, um wahrscheinlich fehlende Zugriffsprofile zu erkennen, ohne den gesamten Katalog zu durchsuchen.',
    [PeerRecommendationListTestIds.peerRecommendationListTitle]: null,
    [PeerRecommendationListTestIds.peerRecommendationListItems]: 'Eine Empfehlung pro Zeile — mit „Hinzufügen” das vorgeschlagene Zugriffsprofil in den aktuellen Antrag aufnehmen.',
  },
}
